export default {
  addRole: '添加角色',
  id: 'ID',
  role: '角色',
  actions: '操作',
  edit: '編輯',
  delete: '刪除',
  addRoleTitle: '添加角色',
  editRoleTitle: '編輯角色',
  roleName: '角色名稱',
  roleNamePlaceholder: '請輸入角色名稱',
  rolePermissions: '角色權限',
  cancel: '取消',
  confirm: '確定',
  level1Menu: '一級菜單',
  level2Menu: '二級菜單',
  confirmDelete: '確定刪除該角色',
};
